import { Family as FontFamily, Weight as FontWeight } from "./utils";

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export const Weight = FontWeight;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export type Weight = FontWeight;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export const Family = FontFamily;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export type Family = FontFamily;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export type WeightKey = keyof typeof Weight;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export type WeightValue = (typeof Weight)[WeightKey];

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export type WeightOrKey = WeightKey | WeightValue;

/** @deprecated use variants from Typography instead */
export const getWeight = (weight: WeightOrKey): WeightValue => {
  if (weight in Weight) {
    return Weight[weight as WeightKey];
  }
  return weight as WeightValue;
};

/** @deprecated Don't use uppercase or capitalize. We are using sentence case instead */
export const TextTransform = {
  capitalize: "capitalize",
  uppercase: "uppercase",
} as const;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export type TypographyStyleProps = {
  "font-family": string;
  "font-weight": string;
  "font-size": string;
  "line-height": string;
  "letter-spacing": string;
  color?: string;
  "text-align"?: string;
  "text-transform"?: string;
  "font-style"?: string;
  "white-space"?: string;
  "text-overflow"?: string;
  overflow?: string;
};

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export const Size = {
  h1: "52px",
  h2: "28px",
  h3: "20px",
  h4: "16px",
  h5: "12px",
  p: "12px",
  small: "10px",
} as const;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export const LineHeight = {
  h1: "64px",
  h2: "40px",
  h3: "32px",
  h4: "28px",
  h5: "20px",
  p: "20px",
  small: "14px",
} as const;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export const LetterSpacing = {
  h1: "2px",
  h2: "1px",
  h3: "1px",
  h4: "0.5px",
  h5: "0.25px",
  p: "0.25px",
  small: "0.25px",
} as const;

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export default {
  Family,
  Weight,
  LineHeight,
  Size,
  LetterSpacing,
};
